
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kompetisi/linefollower",
      function () {
        return require("private-next-pages/kompetisi/linefollower/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kompetisi/linefollower"])
      });
    }
  